import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var TickInCircleSystemIcon = function TickInCircleSystemIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M12.025 23.892c6.558 0 11.875-5.317 11.875-11.876C23.9 5.457 18.583.14 12.025.14 5.465.14.149 5.457.149 12.016c0 6.559 5.317 11.876 11.876 11.876zm0-1.5c-5.73 0-10.376-4.646-10.376-10.376 0-5.73 4.645-10.376 10.376-10.376 5.73 0 10.375 4.645 10.375 10.376 0 5.73-4.645 10.376-10.375 10.376zm-1.227-5.357l7.477-8.91a.75.75 0 00-1.15-.965l-6.92 8.248-3.344-3.73a.75.75 0 00-1.117 1l3.92 4.376a.75.75 0 001.134-.019z"
  })));
};

TickInCircleSystemIcon.displayName = "TickInCircleSystemIcon";
TickInCircleSystemIcon.defaultProps = {
  size: 24
};
TickInCircleSystemIcon.displayName = "TickInCircleSystemIcon";
TickInCircleSystemIcon.iconName = "TickInCircle";
export default TickInCircleSystemIcon;